import { FolderOpenOutlined, FolderOutlined } from '@ant-design/icons';
import { CartelleProcedimentoAreaPubblicaDto } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import {
  DividerTitleElement,
  TableActionsCellSpace,
  TableData,
} from '@framework/ui';
import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { PublicFileDownloadButton } from './PublicFileDownloadButton';
import { TableIconSize } from './TableIconSize';
import { foldersColumns } from './foldersColumns';
import { getTableTreeDataFromCartelle } from './getTableTreeDataFromCartelle';

const TableFolderTreeWrapper = styled.div`
  .ant-table {
    .ant-table-cell.ant-table-cell-with-append {
      text-wrap: nowrap;
    }
  }
`;
const TableFolderButton = styled(Button)`
  &.ant-btn {
    padding: 0;
    font-size: 18px;
  }
`;

export interface IFolderTreeTableProps {
  data?: CartelleProcedimentoAreaPubblicaDto;
  loading?: boolean;
}

/**
 * ...
 */
export function FolderTreeTable(props: IFolderTreeTableProps) {
  const { data, loading } = props;
  const { t } = useTranslation();
  // if (!data) return null;

  // conversione per dati tabella Tree View
  const folders = getTableTreeDataFromCartelle(data);

  return (
    <TableFolderTreeWrapper>
      <DividerTitleElement
        title={t('observation-details.documenti', 'Documenti')}
        removeTopMargin
      />

      <TableData
        showSorterTooltip={false}
        size="small"
        columns={[
          ...foldersColumns,
          {
            title: t('observation-details.azioni', 'Azioni'),
            key: 'actions',
            align: 'right',
            width: 60,
            render: (text, record) =>
              record.type === 'folder' ? null : (
                <TableActionsCellSpace>
                  <PublicFileDownloadButton record={record} />
                </TableActionsCellSpace>
              ),
          },
        ]}
        dataSource={folders ?? []}
        loading={loading}
        pagination={false}
        expandable={{
          expandRowByClick: true,
          // defaultExpandAllRows: true,
          indentSize: 24,
          expandIcon: ({ expanded, onExpand, record }) =>
            record.type === 'folder' ? (
              <TableIconSize style={{ marginRight: 8 }}>
                <TableFolderButton
                  type="link"
                  onClick={e => {
                    onExpand(record, e);
                    e.stopPropagation();
                  }}
                  aria-label={
                    !expanded
                      ? t(
                          'observation-details.apri-cartella',
                          `Apri cartella {{recordName}}`,
                          {
                            recordName: record.nome ?? '',
                          },
                        )
                      : t(
                          'observation-details.chiudi-cartella',
                          `Chiudi cartella {{recordName}}`,
                          {
                            recordName: record.nome ?? '',
                          },
                        )
                  }
                >
                  {expanded ? (
                    <FolderOpenOutlined aria-hidden />
                  ) : (
                    <FolderOutlined aria-hidden />
                  )}
                </TableFolderButton>
              </TableIconSize>
            ) : undefined,
        }}
      />
    </TableFolderTreeWrapper>
  );
}
